export default __webpack_public_path__ + "static/media/typecrane.90e1c901.svg";